import { ApolloError, gql, useQuery } from '@apollo/client';
import { StructureWithParents } from '@lib/structures';

const structureSearchQuery = gql`
  query StructureSearch($searchText: String!) {
    structureSearch(searchText: $searchText) {
      type
      code
      name
      parents {
        type
        code
        name
      }
    }
  }
`;

interface StructureSearchQuery {
  structureSearch: StructureWithParents[];
}

interface StructureSearchArgs {
  searchText: string;
}

interface StructureSearchReturns {
  loading: boolean;
  error?: ApolloError;
  structures?: StructureWithParents[];
}

export default function useStructureSearch(
  searchText: string
): StructureSearchReturns {
  const trimmed = searchText.trim();
  const { error, loading, data } = useQuery<
    StructureSearchQuery,
    StructureSearchArgs
  >(structureSearchQuery, {
    variables: { searchText: trimmed },
    skip: trimmed.length < 3,
  });

  if (error != null) throw error;

  return {
    loading,
    error,
    structures: data?.structureSearch,
  };
}
